/* Role vocabulary shared by Team and Invite user.
   Values must match utils/enum.py::Reviewer and the role list the API returns. */
export const ROLES = [
  { value: "super_admin", label: "Super Admin", description: "Full access, including team management" },
  { value: "admin", label: "Admin", description: "Everything except super-admin management" },
  { value: "agent_onboarding", label: "Partner Onboarding", description: "Review and approve partners" },
  { value: "sessions", label: "Sessions", description: "View and manage booked sessions" },
  { value: "support", label: "Support", description: "Tickets and order follow-ups" },
  { value: "report", label: "Report", description: "Review generated reports" },
  { value: "order_report", label: "Order Report", description: "Order reports for clients" },
  { value: "name_correction", label: "Name Correction", description: "Write numerology corrections" },
  { value: "promotion", label: "Promotion", description: "Banners, coupons and page sections" },
  { value: "app_video", label: "App Video", description: "Home-screen videos" },
  { value: "blog", label: "Blog", description: "Write and publish posts" },
  { value: "ai_astrologer", label: "AI Astrologer", description: "AI chat usage and transcripts" },
  { value: "send_notification", label: "Send Notification", description: "Bulk email and WhatsApp" },
];

/* Modules x capability, for the invite screen's permission matrix. Derived from the
   role list so an admin can see what an invitee will actually reach. */
export const PERMISSION_MATRIX = [
  { module: "Dashboard", roles: ["super_admin", "admin"] },
  { module: "Partner onboarding", roles: ["super_admin", "admin", "agent_onboarding"] },
  { module: "Bank approvals", roles: ["super_admin", "admin"] },
  { module: "Payouts", roles: ["super_admin", "admin"] },
  { module: "Sessions", roles: ["super_admin", "admin", "sessions"] },
  { module: "Support tickets", roles: ["super_admin", "admin", "support"] },
  { module: "Order follow-up", roles: ["super_admin", "admin", "support"] },
  { module: "Reports", roles: ["super_admin", "admin", "report"] },
  { module: "Order report", roles: ["super_admin", "admin", "order_report"] },
  { module: "Name correction", roles: ["super_admin", "admin", "name_correction"] },
  { module: "Coupons", roles: ["super_admin", "admin", "promotion"] },
  { module: "Banners & sections", roles: ["super_admin", "admin", "promotion"] },
  { module: "App video", roles: ["super_admin", "admin", "app_video"] },
  { module: "Blog", roles: ["super_admin", "admin", "blog"] },
  { module: "Messaging templates", roles: ["super_admin", "admin"] },
  { module: "AI Chat", roles: ["super_admin", "admin", "ai_astrologer"] },
  { module: "Team & invites", roles: ["super_admin", "admin"] },
];
